import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateTransactionStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateTransactionStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldUpdateTransactionStatusAttempt', handleUpdateTransactionStatus, api);
}

function* handleUpdateTransactionStatus(api: ApprovalGateway, data: PayloadAction<TUpdateTransactionStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        transactionId,
        status,
        confirmAutoRejectPendingTransactions,
    } = data.payload;

    const response = yield* call([api, api.updateTransactionStatus], {
        authToken,
        transactionId,
        status,
        confirmAutoRejectPendingTransactions,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldUpdateTransactionStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === TransactionStatusEnum.Cancelled
            ? SuccessMessages.GoldCancelTransactionSuccess
            : '';

        yield put(combinedActions.goldSetConfirmUpdateTransactionStatusModalIsOpen(false));
        yield put(combinedActions.goldSetConfirmUpdateCancelTransactionModalIsOpen(false));

        toast.success(successMessage);

        yield put(combinedActions.goldGetTransactionListingAttempt());
        yield put(combinedActions.goldUpdateTransactionStatusSuccess());
    }
}
